type CachedBody = { seq: number; body: string };

const bodies = new Map<string, CachedBody>();

function cacheKey(noteId: string, revisionId?: number): string {
  return `${noteId}:${revisionId ?? 'current'}`;
}

export function cacheNoteBody(noteId: string, seq: number, body: string, revisionId?: number): void {
  bodies.set(cacheKey(noteId, revisionId), { seq, body });
}

export function getCachedNoteBody(noteId: string, seq: number, revisionId?: number): string | undefined {
  const cached = bodies.get(cacheKey(noteId, revisionId));
  return cached?.seq === seq ? cached.body : undefined;
}

export function getCachedNoteBodies(noteId: string): string[] {
  const prefix = `${noteId}:`;
  return Array.from(bodies.entries())
    .filter(([key]) => key.startsWith(prefix))
    .map(([, value]) => value.body);
}

export function clearNoteBodyCache(noteId?: string): void {
  if (!noteId) {
    bodies.clear();
    return;
  }
  for (const key of bodies.keys()) {
    if (key.startsWith(`${noteId}:`)) bodies.delete(key);
  }
}
